import Search from '@/components/Search'
import DialogButton from '@/components/Dialogs/DialogButton'
import DialogButton1 from '@/components/Dialogs/DialogButton1'
import DialogPay from '@/components/Dialogs/DialogPay'

export default {
  components: {
    DialogButton,Search,DialogPay,DialogButton1
  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      btnType:'success',
      loading: false,
      money: 0,
      btnContent:'',
      width:'564px',
      url: {
        get: SZH.assets.api + "/Custom/GetCustomCanUseMonyeForWeb",
        GetCustomCanUseMonyeForWeb: SZH.assets.api + "/OnlinePay/GetCustomPaymentCanUseMonyeForWeb",
        GetCompanyCanUseMonyeForWeb: SZH.assets.api + "/OnlinePay/GetCompanyPaymentCanUseMonyeForWeb",
        check: SZH.assets.api + "/UnionPay/QueryOrderState",
        pay: SZH.assets.api + "/UnionPay/Pay",
        payOnline: SZH.assets.api + "/OnlinePay/Pay",
        GetCompanyItem:SZH.assets.api + '/Custom/GetCompanyItem',
        QueryOrderState:SZH.assets.api + '/OnlinePay/QueryOrderState',
        GetOnlinePayDisplay:SZH.assets.api + '/Custom/GetOnlinePayDisplay',//企业（个人）货款是否显示
        GetSelectWareHouseForWeb:SZH.assets.api + '/WareHouse/GetSelectWareHouseForWeb',//企业（个人）货款是否显示

      },
      moneyList: [
        {money:100,coolMoney:100.30,active:true},
        {money:200,coolMoney:200.60,active:false},
        {money:500,coolMoney:501.50,active:false},
        {money:1000,coolMoney:1003.01,active:false},
        {money:2000,coolMoney:2006.02,active:false},
      ],
      moneyList1: [
        {money:100,coolMoney:100.30,active:true},
        {money:200,coolMoney:200.60,active:false},
        {money:500,coolMoney:501.50,active:false},
        {money:1000,coolMoney:1003.01,active:false},
        {money:2000,coolMoney:2006.02,active:false},
      ],
      visible: false,
      title: '请在新打开的页面完成支付',
      paystate: 1,
      id: null,
      payLoading: false,
      moneyPerson:0,
      moneyCompany:0,
      warhouseSelect:[],
      comFlag:false,
      loadingPerson:false,
      loadingCom:false,
      visibleHk:false,
      companyId:'',
      companyDisplay:'0',
      customDisplay:'0',
      queryObj:{
        keyValue:'',
        Keyword:''
      },
      PaymentType:''
    }
  },
  methods:{
    handleCommand(command){
      let self = this;
      self.comFlag = true;
      self.companyId = command;
      self.loadDataCompanyMoney(command);
    },
    getCompany(){
      let self = this;
      self.$http.post(self.url.GetSelectWareHouseForWeb,{
      }).then(result =>{
        if(result.state == true && result.data && result.data.length>0){
          self.warhouseSelect = result.data;
        }else{
          self.warhouseSelect = [];
        }
      }, () => {

      });
    },
    toFixed(number) {
      var num = parseFloat(number == null ? 0 : number);
      return num != null && num != undefined ? num.toFixed(2) : '0.00'
    },
    //个人货款
    loadDataGrhk() {
      var self = this;
      self.loadingPerson = true;
      self.$http.post(self.url.GetCustomCanUseMonyeForWeb, self.queryObj).then(result => {
        if (result.state == true && result.data != null) {
          self.moneyPerson = result.data;
        } else {
          self.moneyPerson = 0;
        }
        self.loadingPerson = false;
      }, () => {
        self.loadingPerson = false;
      });
    },
    loadDataCompanyMoney(id) {
      var self = this;
      self.loadingCom = true;
      self.$http.post(self.url.GetCompanyCanUseMonyeForWeb, {
        Data:id
      }).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.moneyCompany = result.Data;
        } else {
          self.moneyCompany = 0;
        }
        self.loadingCom = false
      }, () => {
        self.loadingCom = false
      });
    },
    goBack() {
      this.$router.push({
        path: '/My/userInfo'
      })
    },
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    isPhone(screen) {
      return screen.width <= 450;
    },
    clickButton(){
      for(var i = 0;i<this.moneyList.length;i++){
        this.moneyList[i].active = false;
      }
      this.moneyList[0].active = true
    },
    onpay(id) {
      this.visible = true;
      this.id = id;
      this.paystate = 1;
    },
    //货款
    onpayHk(obj) {
      this.visibleHk = true;
      this.id = obj.orderId;
      this.PaymentType = obj.PaymentType;
      this.paystate = 1;
    },
    payok() {
      this.title = "充值成功！";
      this.paystate = 0;
    },
    close() {
      this.visible = false;
    },
    closeHk(){
      this.visibleHk = false;
    },
    // 支付
    clickBtn(money){
      for(var i = 0;i<this.moneyList.length;i++){
        this.moneyList[i].active = false;
        if(this.moneyList[i].money == money){
          this.moneyList[i].active = true
        }
      }
    },
    onClose(id) {
      this.visible = false;
    },
    // 我已支付
    checkPayState() {
      var self = this;
      self.payLoading = true;
      self.$http.post(self.url.check, { keyValue: self.id }).then(result => {
        if (result.state == true) {
          self.payok();
          self.loadData();
        } else {
          self.$message.error("很抱歉，我们暂时没有查询到您的充值记录，如您已完成支付，请稍后再次尝试查询。")
        }
        self.payLoading = false;
      }, () => {
        self.payLoading = false;
      });
    },
    checkPayHkState() {
      var self = this;
      self.payLoading = true;
      self.$http.post(self.url.QueryOrderState, { OrderId: self.id,PaymentType:self.PaymentType }).then(result => {
        if (result.state == true) {
          self.payok();
          self.loadDataGrhk();
        } else {
          self.$message.error("很抱歉，我们暂时没有查询到您的充值记录，如您已完成支付，请稍后再次尝试查询。")
        }
        self.payLoading = false;
      }, () => {
        self.payLoading = false;
      });
    },
    showDetail() {
    },
    // 重新支付
    payAgain() {
      var self = this;
      self.$http.post(self.url.pay, {
        Data: {
          Id: self.id
        }
      })
        .then(res => {
          if(res.state == true) {
            setTimeout(() => {
              var doc = window.document;
              let param = {
                data:res.Data
              }
              window.sessionStorage.setItem("html",res.Data);
              let routeData = self.$router.resolve({
                path: '/Pay',
                name: 'Pay',
                params: param
              })
              window.open(routeData.href, '_blank')
            }, 100);
          }
          else {
          }
        }, () => {
        });
    },
    payAgainHk(){
      var self = this;
      self.$http.post(self.url.payOnline, {
        keyValue: {
          Id: self.id
        }
      })
        .then(res => {
          if(res.state == 1) {
            setTimeout(() => {
              var doc = window.document;
              let param = {
                data:res.Data
              }
              window.sessionStorage.setItem("html",res.Data);
              let routeData = self.$router.resolve({
                path: '/Pay',
                name: 'Pay',
                params: param
              })
              window.open(routeData.href, '_blank')
            }, 100);
          }
          else {
          }
        }, () => {
        });
    },
    GetOnlinePayDisplayFun(){

      var self = this;
      self.$http.post(self.url.GetOnlinePayDisplay, {

      }).then(res => {
          if(res.State == 1) {
            self.customDisplay = res.Data.CustomPay;
            self.companyDisplay = res.Data.CompanyPay;
          }
          else {
            self.customDisplay = '0';
            self.companyDisplay = '0';
          }
        }, () => {
        });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    if(this.id != null) {
      // this.checkPayState();
    }
    // this.loadDataGrhk();
    this.getCompany();
  }
}



// WEBPACK FOOTER //
// ./src/views/Charge/Charge.js